/**
 * Exchange.js
 *
 * @description :: A model definition.  Represents a database table/collection/etc.
 * @docs        :: https://sailsjs.com/docs/concepts/models-and-orm/models
 */

export default {
     
  tableName: 'exchangerate',
  
  attributes: {

    price: {
      type: 'number',
      required: true,
    },

    dateExchange: {
      type: 'ref',
      columnType: 'date',
      required: true,
    },

  },

}



// WEBPACK FOOTER //
// ./src/models/Exchange.js